import React from 'react';

import Button from './button';
import Icon from './icon';
import Input from './input';
import Modal from './modal';
import Notif from './notification';
import ListItem from './listItem'
import ListCard from './listCard'
import Table from './table';
import TableNew from './tableNew';
import Card from './card';
import Avatar from './avatar';
import Nav from './nav';
import {Title, Text} from './typography';
import CardActionButton from './cardActionButton'
import DynamicForm from './dynamicForm'
import FormInput from './formInput'
import FormTextArea from './formTextArea'
import FormEditor from './formEditor'
import FormCheckBox from './formCheckBox'
import FormImage from './formImage'
import FormSelect, {FormRelated} from './formSelect';
import FormRadio from './formRadio';
import FormUploader from './formUploader'
import Spinner from './spinner';
import FormItem from './formItem';
import DescriptionBox from './descriptionBox';
import Spin from './spin'
import Empty from './empty';
import Pagination from './pagination';

export enum ComponentModesEnum {
    Primary= "_primary",
    Error= "_error",
    Warning= "_warning",
    Info= "_info",
    Success= "_success"
}
export {
    Button,
    Input,
    Modal,
    Notif,
    Table,
    TableNew,
    Card,
    ListCard,
    Avatar,
    Spin,
    Nav,
    Title,
    CardActionButton,
    Text,
    Icon,
    ListItem,
    DynamicForm,
    FormInput,
    FormSelect, FormRelated,
    FormRadio,
    FormTextArea,
    FormEditor,
    FormCheckBox,
    FormImage,
    FormUploader,
    Pagination,
    Spinner,
    FormItem,
    DescriptionBox,
    Empty
}